import { Divider, Drawer, Stack } from '@mui/material';
import { useAtom } from 'jotai';

import { isIPadPro } from '../../../../helpers/iPadProUtil/iPadProUtil';
import { showEventPaneAtom } from '../../../../state/atoms/atoms';
import { EventForm } from '../../Form/EventForm/EventForm';
import { EventPaneActionBar } from '../EventPaneActionBar/EventPaneActionBar';
import { EventPaneHeader } from '../EventPaneHeader/EventPaneHeader';

export const EventPane = () => {
  const [showEventPane, setShowEventPane] = useAtom(showEventPaneAtom);

  const handleClose = () => {
    // Blur any focused element before closing to prevent aria-hidden conflicts
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    // Add a small delay to allow focus to properly release
    setTimeout(() => {
      setShowEventPane(false);
    }, 10);
  };

  return (
    <Drawer
      slotProps={{
        paper: {
          sx: {
            width: isIPadPro ? '100%' : { xs: '100%', sm: '100%', md: '33%' },
          },
        },
      }}
      anchor="right"
      open={showEventPane}
      onClose={handleClose}
      ModalProps={{
        keepMounted: false,
        disableEnforceFocus: true,
        disableAutoFocus: false,
        disableRestoreFocus: true,
      }}
    >
      <Stack>
        <EventPaneHeader />
        <EventPaneActionBar />
        <Divider />
        <EventForm />
      </Stack>
    </Drawer>
  );
};
